{
  "auth": {
    "Adventure starts here 🚀": "Het avontuur begint hier 🚀",
    "Already have an account?": "Hebt u al een account?",
    "Back To Home": "Terug naar Startpagina",
    "Back to login": "Terug naar login",
    "Confirm Password": "Bevestig wachtwoord",
    "Doğrula": "Verifiëren",
    "Doğrulama Kodu": "Verificatiecode",
    "Forgot Password? 🔒": "Wachtwoord vergeten? 🔒",
    "Geri Dön": "Teruggaan",
    "Google Authenticator Kodu": "Google Authenticator-code",
    "I agree to": "Ik ga akkoord met",
    "Login": "Inloggen",
    "New Password": "Nieuw wachtwoord",
    "Password Check": "Wachtwoord Controle",
    "Phone": "Telefoon",
    "Remember me": "Onthoud mij",
    "Reset Password": "Wachtwoord opnieuw instellen",
    "Application Title": "Insurance Management System",
    "logout_message": "Safely logging out...",
    "register_title": "Sign Up",
    "register_description": "Create a new account and explore the benefits",
    "i_accept": "i accept",
    "join_us": "Join Us",
    "join_us_description": "Register now and step into our advantageous world by joining our professional network.",
    "Send Reset Link": "Stuur link voor wachtwoordreset",
    "Set New Password": "Nieuw wachtwoord instellen",
    "Sign in instead": "Log in plaats daarvan in",
    "Sign up": "Registreren",
    "You are not authorized! 🔐": "U bent niet geautoriseerd! 🔐",
    "PermissionDenied": "U heeft geen toestemming om deze pagina te openen. Ga naar de startpagina!",
    "privacy policy & terms": "Ik heb het privacybeleid gelezen en ga ermee akkoord. Ik stem in met de verwerking van mijn persoonsgegevens.",
    "Form gönderilirken bir hata oluştu:": "Er is een fout opgetreden bij het verzenden van het formulier:",
    "Welcome": "Welkom {title}",
    "Soru": "Vraag",
    "Cevap": "Antwoord",
    "Email": "E-mail",
    "Password": "Wachtwoord",
    "Ad Soyad": "Volledige Naam",
    "Forgot Password Description": "Voer uw e-mailadres in en we sturen u instructies om uw wachtwoord opnieuw in te stellen",
    "Your new password must be different from previously used passwords": "Uw nieuwe wachtwoord moet anders zijn dan eerder gebruikte wachtwoorden",
    "Lütfen 6 haneli güvenlik kodunu girin": "Voer uw 6-cijferige veiligheidscode in",
    "İki Adımlı Doğrulama": "Tweestapsverificatie",
    "Doğrulama kodu gönderildi": "Verificatiecode verzonden.",
    "Kodu almadınız mı?": "Code niet ontvangen?",
    "New on our platform?": "Nieuw op ons platform?",
    "Create an account": "Maak een account aan",
    "Make your app management easy and fun!": "Maak uw app beheer gemakkelijk en leuk!",
    "Privacy Policy Title": "Privacybeleid & Voorwaarden",
    "Please Login": "Please log in to your account to continue",
    "Switch Account": "Log in with a different account",
    "Welcome Back": "Welcome Back",
    "Invalid Captcha": "Please check the security code.",
    "Login Title": "Log In",
    "Back to Login Page": "Giriş Sayfasına Dön",
    "Last updated": "Son Güncelleme",
    "Hava Açık": "Hava Açık",
    "Az Bulutlu": "Az Bulutlu",
    "Parçalı Bulutlu": "Parçalı Bulutlu",
    "Kapalı": "Kapalı",
    "Sisli": "Sisli",
    "Çiseleme": "Çiseleme",
    "Yağmurlu": "Yağmurlu",
    "Hafif Yağmur": "Hafif Yağmur",
    "Şiddetli Yağmur": "Şiddetli Yağmur",
    "Kar Yağışlı": "Kar Yağışlı",
    "Fırtına": "Fırtına",
    "Bilinmiyor": "Bilinmiyor",
    "Hissedilen": "Hissedilen",
    "Veri yükleniyor...": "Veri yükleniyor...",
    "Gündüz": "Gündüz",
    "Gece": "Gece",
    "Şimdi Yenile": "Şimdi Yenile"
  }
}
